import { Controller } from "react-hook-form";

export interface RadioOption {
    value: string | number;
    label: string;
}

export interface InputRadioProps {
    name: string;
    label: string;
    methods: any;
    options: RadioOption[];
    row?: boolean;
    disabled?: boolean;
}

export function InputRadio({ name, label, methods, options, row = true, disabled = false }: InputRadioProps) {
    return (
        <Controller
            name={name}
            control={methods.control}
            render={({ field }) => (
                <div className="w-full">
                    <span className="mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300">
                        {label}
                    </span>
                    <div className={`flex gap-4 ${row ? "flex-row flex-wrap" : "flex-col"}`}>
                        {options.map((option) => (
                            <label
                                key={option.value}
                                className={`flex items-center gap-2 text-sm text-slate-700 dark:text-slate-300 ${
                                    disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
                                }`}
                            >
                                <input
                                    type="radio"
                                    name={name}
                                    value={option.value}
                                    checked={(field.value ?? "") === option.value}
                                    onChange={(e) => field.onChange(e.target.value)}
                                    disabled={disabled}
                                    className="h-4 w-4 accent-primary-500 disabled:cursor-not-allowed"
                                />
                                {option.label}
                            </label>
                        ))}
                    </div>
                </div>
            )}
        />
    );
}
